import Http from '../../../../network/Http'
import {NatGetOwnerCondominium} from './NatGetOwnerCondominium';

export default class NatOwnerCondominiumRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 居住者ユーザ所有物件取得
    async getOwnerCondomoinum(sutekiNetId: string, condominiumCd: string): Promise<NatGetOwnerCondominium> {
        return await this.http.get(`/api/admin/ownerCondominium/${encodeURIComponent(sutekiNetId)}/${encodeURIComponent(condominiumCd)}`);
    }
}
